var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/brand-urls.j2"] = require( "macros/brand-urls.j2" );
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/modal/product-create-registry.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/brand-urls.j2", false, "product/templates/modal/product-create-registry.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("registryUrl")) {
var t_4 = t_1.registryUrl;
} else {
cb(new Error("cannot import 'registryUrl'")); return;
}
context.setVariable("registryUrl", t_4);
output += "\n\n";
env.getTemplate("modal/modal-contents.j2", true, "product/templates/modal/product-create-registry.j2", false, function(t_6,_parentTemplate) {
if(t_6) { cb(t_6); return; }
parentTemplate = _parentTemplate
for(var t_5 in parentTemplate.blocks) {
context.addBlock(t_5, parentTemplate.blocks[t_5]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n    o-modal--small c-registry-modal__create\n\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n    <div class=\"o-row o-row--space c-registry-modal__create--text u-centered-content\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <h2 class=\"c-registry-modal__h2\">\n\n                ";
output += runtime.suppressValue((lineno = 18, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_missing-registry-text"])), env.opts.autoescape);
output += "\n\n            </h2>\n\n            <p class=\"u-global-p\">\n\n                ";
output += runtime.suppressValue((lineno = 24, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_create-a-registry-text"])), env.opts.autoescape);
output += "\n\n            </p>\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row u-centered-content\">\n\n        <div class=\"o-row o-column o-extra-small--12\">\n\n            <div class=\"o-column o-extra-small--12 o-large--8\">\n\n                <a href=\"";
output += runtime.suppressValue((lineno = 38, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "registryUrl"), "registryUrl", context, ["create"])), env.opts.autoescape);
output += "\"\n                    class=\"js-modal-create-registry c-button-primary\"\n                    aria-controls=\"a-create-registry\">\n\n                        ";
output += runtime.suppressValue((lineno = 42, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_create-registry-button"])), env.opts.autoescape);
output += "\n                </a>\n\n            </div>\n\n            <div class=\"o-column o-extra-small--12 o-large--4 c-registry-modal__create--cancel\">\n\n                <a href=\"\"\n                    class=\"js-modal__cancel c-button-text\">\n\n                        ";
output += runtime.suppressValue((lineno = 52, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_cancel-registry-button"])), env.opts.autoescape);
output += "\n\n                </a>\n\n            </div>\n\n        </div>\n\n    </div>\n\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/modal/product-create-registry.j2"] , dependencies)